import * as Immutable from 'immutable';
import {
  GET_PLAN_PERFORMANCE_ABORTED,
  GET_PLAN_PERFORMANCE_REQUESTED,
  GET_PLAN_PERFORMANCE_COMPLETED,
  GET_PLAN_PERFORMANCE_FAILED,
  SET_PLAN_PERFORMANCE_FILTER_REQUESTED,
  SET_PLAN_PERFORMANCE_FILTER_COMPLETED,
  SET_PLAN_PERFORMANCE_FILTER_FAILED,
  // RESET_PLAN_PERFORMANCE_REQUESTED,
  // RESET_PLAN_PERFORMANCE_COMPLETED,
} from '../../actions/planperformance/types';

const schema = {
  // status: 'INIT', // INIT/OK/ERROR
  error: null,
  data: { items: [] },
  resettingdata: false,
  gettingdata: false,
  gotdata: false,
  settingfilter: false,
  setfilter: false,
};

const initialState = Immutable.Map(schema);

// eslint-disable-next-line @typescript-eslint/default-param-last
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_PLAN_PERFORMANCE_ABORTED:
      return state.set('error', null).set('gettingdata', false);

    case GET_PLAN_PERFORMANCE_REQUESTED:
      return state.set('error', null).set('gettingdata', true);

    case GET_PLAN_PERFORMANCE_COMPLETED:
      return state
        .set('error', null)
        .set('gettingdata', false)
        .set('gotdata', true)
        .set('data', action.payload);

    case GET_PLAN_PERFORMANCE_FAILED:
      return state.set('error', action.payload);

    case SET_PLAN_PERFORMANCE_FILTER_REQUESTED:
      return state
        .set('error', null)
        .set('setfilter', false)
        .set('settingfilter', true);

    case SET_PLAN_PERFORMANCE_FILTER_COMPLETED:
      return state
        .set('error', null)
        .set('settingfilter', false)
        .set('setfilter', true)
        .set('data', action.payload);

    case SET_PLAN_PERFORMANCE_FILTER_FAILED:
      return state.set('error', action.payload);

    default:
      return state;
  }
};

export { initialState };

export default reducer;
